
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleReleaseList(
    console_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/${console_id}/release/list${queryString}`
    );
}

export async function consoleReleaseGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/console/release/${item_id}/show`
    );
}

export async function consoleReleaseCreate(
    console_id: string,
    payload: Partial<any>
) {
    return await clientAxios.post(
        `admin/console/${console_id}/release/create`,
        payload
    );
}

export async function consoleReleasePatch(
    item_id: string,
    payload: Partial<any>
) {
    return await clientAxios.patch(
        `admin/console/release/${item_id}/patch`,
        { payload }
    );
}

export async function consoleReleaseDel(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/console/release/${item_id}/delete`,
    );
}
